<template>
  <v-dialog v-model="dialog" max-width="1000px">
    <v-card>
      <v-card-title>
        <span class="text-h5">{{
          (editedItem.id && `Editar ${editedItem.Causa_de_la_cita}`) ||
            "Nuevo tratamiento"
        }}</span>
      </v-card-title>

      <v-card flat>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="10">
                <v-text-field
                  v-model="editedItem.Causa_de_la_cita"
                  label="Nombre"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-switch
                  v-model="editedItem.Finalizado"
                  label="Finalizado"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-subheader class="pl-0">
                  Descripción:
                </v-subheader>
                <tiptap-vuetify
                  v-model="editedItem.Descripcion"
                  :extensions="extensions"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-subheader class="pl-0">
                  Escala numérica del dolor:
                </v-subheader>
                <v-slider
                  min="0"
                  max="10"
                  step="1"
                  ticks="always"
                  tick-size="1"
                  v-model="editedItem.Escala_numerica_dolor"
                  :tick-labels="ticksLabels"
                ></v-slider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  min="0"
                  max="10"
                  step="1"
                  :tick-labels="ticksLabels"
                  v-model="editedItem.Escala_descriptiva_intesidad_dolor"
                  :items="painRankItems"
                  item-text="text"
                  item-value="value"
                  label="Escala descriptiva de la intesidad del dolor"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="4">
                <pain-point-picker
                  v-model="editedItem.frontPoints"
                  view="front"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4">
                <pain-point-picker
                  v-model="editedItem.backPoints"
                  view="back"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4">
                <pain-point-picker
                  v-model="editedItem.sidePoints"
                  view="side"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="11">
                <DatePicker v-model="newVisitDate" label="Añadir Visita" />
              </v-col>
              <v-col cols="12" sm="12" md="1">
                <v-btn
                  @click="addNewVisitDate"
                  class="mx-2"
                  fab
                  dark
                  small
                  color="primary"
                >
                  <v-icon dark>
                    mdi-plus
                  </v-icon>
                </v-btn></v-col
              >
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-list expand>
                  <v-subheader inset>Visitas</v-subheader>

                  <v-list-item
                    v-for="(appoiment, index) in editedItem.Visitas"
                    :key="index"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="appoiment.fecha"
                      ></v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-btn @click="removeVisitDate(index)" icon>
                        <v-icon color="red lighten-1">mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close">
          Cancelar
        </v-btn>
        <v-btn color="green darken-1" text @click="save">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import PainPointPicker from "@/components/PainPointPicker.vue";
import { throwStatement } from "@babel/types";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";

export default {
  components: { TiptapVuetify, DatePicker, PainPointPicker },
  props: ["visible", "item"],
  data: () => {
    return {
      newVisitDate: null,
      ticksLabels: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      painRankItems: [
        {
          text: "Sin dolor",
          value: "Sin_dolor",
        },
        {
          text: "Dolor leve",
          value: "Dolor_leve",
        },
        {
          text: "Dolor moderado",
          value: "Dolor_moderado",
        },
        {
          text: "Dolor intenso",
          value: "Dolor_intenso",
        },
        {
          text: "Dolor muy intenso",
          value: "Dolor_muy_intenso",
        },
        {
          text: "El peor dolor que pueda existir",
          value: "El_peor_dolor_que_pueda_existir",
        },
      ],
      editedItem: {},
      dialog: false,
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
    };
  },
  mounted() {
    this.editedItem = this.item;
    this.dialog = this.visible;
  },
  watch: {
    item: {
      handler(val) {
        this.editedItem = val;
      },
      deep: true,
    },
    visible: {
      handler(val) {
        this.dialog = val;
      },
    },
  },
  methods: {
    removeVisitDate(idx) {
      this.editedItem.Visitas.splice(idx, 1);
    },
    addNewVisitDate() {
      this.editedItem.Visitas.push({
        fecha: this.newVisitDate,
      });
      this.newVisitDate = null;
    },
    save() {
      this.editedItem.frontPoints = JSON.stringify(this.editedItem.frontPoints);
      this.editedItem.backPoints = JSON.stringify(this.editedItem.backPoints);
      this.editedItem.sidePoints = JSON.stringify(this.editedItem.sidePoints);
      this.$emit("save", this.editedItem);
      this.editedItem = {};
    },
    close() {
      this.$emit("close");
      this.editedItem = {};
    },
  },
};
</script>
